import "./subcategory-block.scss";

(function () {
    if (document.querySelectorAll(".subcategory-block").length > 0) {

        const subCategoryBlock = {
            init: function () {
                const categoryBlocks = document.querySelectorAll(".js-subcategory-block");

                if (categoryBlocks !== null) {
                    categoryBlocks.forEach(categoryBlock => {
                        const buttons = categoryBlock.querySelectorAll(".subcategory__button");

                        buttons.forEach(button => button.addEventListener("click", (e) => {
                            const button = e.currentTarget;

                            if (button) {
                                const carousel = categoryBlock.querySelector(".subcategory-block .subcategory__carousel");
                                const selectedProduct = button.getAttribute("data-index");
                                const selectedItem = carousel.querySelectorAll(".subcategory__carousel__item");

                                selectedItem.forEach(item => {
                                    if (item.classList.contains(`item-${selectedProduct}`)) {
                                        item.style.display = "grid";
                                    }
                                    else {
                                        item.style.display = "none";
                                    }
                                });

                                buttons.forEach(b => b.classList.remove("selected"))
                                button.classList.add("selected")
                            }
                        }));

                        buttons[0].classList.add("selected");
                    })
                }
               
            },
        };

        subCategoryBlock.init();
    }
})();
